import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import logoImg from '../../assets/images/logo.png';
import menuIcon from '../../assets/images/menu.svg';
import closeIcon from '../../assets/images/close.svg';

import './styles.css';

function Header() {
  const timelineEl = React.useRef<HTMLDivElement>(null);


  const [open, setOpen] = useState(false)
  // const [displayMenu, setDisplayMenu] = useState({ display: 'none' })

  const openMenuNavMobile = () => {
    if (open) {

      timelineEl.current?.classList.add('hide')
      // setDisplayMenu({ display: 'none' })
      setOpen(false)
    }
    else {
      timelineEl.current?.classList.remove('hide')
      // setDisplayMenu({ display: 'flex' })
      setOpen(true)
    }
  }

  return (
    <div className="header">
      <div className="container page-header ">
        <div className="logo">
          <Link to="/" > <img src={logoImg} alt="Eólica" /></Link>

        </div>
        <div className="nav-header-links">
          <Link to="/" > HOME</Link>
          <Link to="/aboutus" > ABOUT</Link>
          <Link to="/onshore" > ONSHORE WIND</Link>
          <Link to="/solar" > SOLAR</Link>
          {/* <div className="dropdown">
            <div className="dropdown-title">Smart O&M </div>
            <div className="arrow-down"></div>
            <div className="dropdown-content">
              <Link to="/cms" className="nav-header-dropdown"> Condition Monitoring System</Link>
              <Link to="/pms" className="nav-header-dropdown"> Performance Monitoring System</Link>
              <Link to="/windintelli" className="nav-header-dropdown"> WindIntelli</Link>
            </div>
          </div> */ }
          <Link to="/windintelli" className="nav-header-dropdown"> Smart O&M </Link>
          { /* <Link to="/sustainability" > SUSTAINABILITY</Link> */ }
          <Link to="/contact" > CONTACT</Link>
        </div>
        {
          open ? <img src={closeIcon} alt="Menu" className="nav-menu filter-color" onClick={openMenuNavMobile} /> 
          : <img src={menuIcon} alt="Menu" className="nav-menu filter-color" onClick={openMenuNavMobile} />
        }
        <div ref={timelineEl} className="nav-menu-mobile hide">
          <Link to="/" > HOME</Link>
          <Link to="/aboutus" > ABOUT</Link>
          <Link to="/onshore" > ONSHORE WIND</Link>
          <Link to="/solar" > SOLAR</Link>
          { /* <div className="dropdown">
            <div className="dropdown-title">Smart O&M </div>
            <div className="dropdown-content-mobile">
              <Link to="/cms" className="nav-header-dropdown"> - CMS</Link>
              <Link to="/pms" className="nav-header-dropdown"> - PMS</Link>
              <Link to="/windintelli" className="nav-header-dropdown"> WindIntelli</Link>
            </div>
          </div> */ }

          <Link to="/windintelli" className="nav-header-dropdown"> SMART O&M</Link>
          { /* <Link to="/sustainability" > SUSTAINABILITY</Link> */ }
          <Link to="/contact" > CONTACT</Link>
        </div>
      </div>
    </div>
  )
}

export default Header;